export const LOCAL_STORAGE_KEYS = {
  JWT_TOKEN: "jwt",
  ATTRIBUTION: "attribution"
}
